<template>
  <div>
    <general-table
      ref="generalTable"
      :api-url="apiUrl"
      :add-component-name="addComponentName"
      :edit-component="editComponent"
      :delete-content="true"
      :block-content="false"
      :edit-content="true"
      :view-content="false"
      :add-type="addType"
      :columns="columns"
      :type="type"
    >
      <template #cell(user)="data">
        <div class="d-flex py-1">
          <div style="margin-right:10px ;">
            <b-avatar size="40" />
          </div>
          <div class="d-flex flex-column justify-content-start align-items-start">
            <span>{{ data.item.user.name }}</span>
            <span class="text-muted">{{ data.item.user.email }}</span>
          </div>
        </div>
      </template>

      <template #cell(request)="data">
        <!-- Sticky Cell for Request Code  control-->
        <RequestCodeCell
          :data="data"
          :types="'reimbursement'"
        />
      </template>

      <template #cell(approved)="data">
        <div class="d-flex justify-content-center">
          <feather-icon
            v-if="data.item.status === 'approved'"
            icon="CheckCircleIcon"
            size="20"
            color="green"
          />
          <feather-icon
            v-if="data.item.status === 'rejected'"
            icon="XCircleIcon"
            size="20"
            color="red"
          />
          <div v-if="data.item.status === 'pending'">
            <b-btn
              size="sm"
              variant="outline-success"
              class="mr-1 onhoverBtn"
              @click="approve(data.item.id)"
            >
              Approve
            </b-btn>
            <b-btn
              size="sm"
              variant="outline-danger"
              class="onhoverBtn"
              @click="reject(data.item.id)"
            >
              Reject
            </b-btn>
          </div>
        </div>
      </template>
      <template #cell(attachments)="data">
        <div class="d-flex justify-content-around">
          <div
            v-for="(attachment , index) in data.item.attachments"
            :key="attachment.id"
          >
            <a
              :href="attachment.url"
              target="_blank"
              class="text-dark d-flex flex-column"
            >
              <feather-icon
                icon="FileIcon"
                size="20"
              />
              {{ index + 1 }}
            </a>
          </div>
        </div>
      </template>
    </general-table>
  </div>
</template>

<script>
import axios from 'axios'
import GeneralTable from '@/components/general-table/GeneralTable.vue'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import RequestCodeCell from '@/views/requests/template-cell-requests-table/RequestCodeCell.vue'

export default {
  components: { GeneralTable, FeatherIcon, RequestCodeCell },
  data() {
    return {
      APIURL: 'reimbursement',
      addType: 'Add Reimbursement',
      addComponentName: 'add-reimbursement',
      editComponent: 'edit-reimbursement',
      viewContent: false,
      type: 'page',
      partners: [],
      filter: {},
      types: '',
      columns: [
        { key: 'user', label: 'user' },
        { key: 'request', label: 'Request Code' },
        { key: 'description', label: 'description' },
        { key: 'amount', label: 'amount' },
        { key: 'status', label: 'status' },
        { key: 'attachments', label: 'attachments' },
        { key: 'approved', label: 'Approved' },
        { key: 'actions' },
      ],
    }
  },

  computed: {
    apiUrl() {
      let base = 'reimbursement?'

      if (!Object.values(this.filter).length) {
        return base.slice(0, -1)
      }

      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(this.filter)) {
        if (key && value) {
          base += `${key}=${value}&`
        }
      }
      // console.log(base.slice(0, -1))
      return base.slice(0, -1)
    },
  },

  methods: {
    filterTypes(type) {
      const filteredType = this.status.filter(item => item.text !== type)
      this.types = filteredType
    },

    approve(id) {
      this.$swal({
        title: 'Are you sure you want to approve?',
        width: 600,
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Approve',
        cancelButtonText: 'Cancel',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
      }).then(result => {
        if (result.isConfirmed) {
          axios.patch(`reimbursement/${id}/approve`)
            .then(() => {
              this.$toast.success('Approved Successfully!')
              this.$refs.generalTable.getAllData(1)
            })
            .catch(() => {
              this.$toast.error('Failed to approve.')
            })
        }
      })
    },
    reject(id) {
      this.$swal({
        title: 'Are you sure you want to reject?',
        width: 600,
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Reject',
        cancelButtonText: 'Cancel',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
      }).then(result => {
        if (result.isConfirmed) {
          axios.patch(`reimbursement/${id}/reject`)
            .then(() => {
              this.$toast.success('Reject Successfully!')
              this.$refs.generalTable.getAllData(1)
            })
            .catch(() => {
              this.$toast.error('Failed to approve.')
            })
        }
      })
    },
  },
}
</script>

<style>
.onhoverBtn:hover {
  color: white !important;
  border: 1px solid white !important;
  background-color: transparent !important;
}
</style>
